import { Location } from './location.interface';
import { agentQuestion } from '@pages/consorcios/consorcios.config';
import { MessageBalance } from './message-balance';

export type UserStatus =
    | 'active'
    | 'inactive'
    | 'pending'
    | 'deleted'
    | 'rejected'
    | 'activeLink';

export type Role = 'company' | 'person';

export interface UserAuth {
    email: string;
    password: string;
}

export type UserType =
    | 'customer'
    | 'admin'
    | 'provider'
    | 'franchise'
    | 'support'
    | 'administration';

export interface User extends UserAuth {
    uid?: string;
    parentUid: string;
    phoneArea: string;
   phoneNumber:number | string;
    companyName?: string;
    firstName?: string;
    lastName?: string;
    cuit: string;
    status: UserStatus;
    role: Role;
    locations: Location[];
    code?: string;
    fcmTokens?: string;
    type?: UserType;
    activeBO?: boolean;
    redsocial?: boolean;
    numOrders?: number;
    dni: string;
}

export interface Person extends User {
    firstName: string;
    lastName: string;
}
export interface Company extends User {
    companyName: string;
    cuit: string;
}

export interface Provider extends User {
  firstName: string;
  lastName: string;
  cuit: string;
  profileType?: string;
  rubros?: any[];
  additionalData?: any;
  points?: number;
  orderUnqualified?: string[];
  institutions?: any[];
  featured?: string;
  cbu?:string;
}
export interface PersonalProvider {
  firstName: string;
  lastName: string;
  companyName?: string;
  cuit?: string;
  phoneNumber:number | string;
  phoneArea:string;
  cbu?:string;
}

//categoría del abono: una clave de parametry/pricing.plans ('A', 'B', 'C', o la de prueba) o 'Free' sin suscripción (AF319).
//BASIC, PRO y PROPLUS son los planes anteriores: se leen como A, B y C (planKey en pages/parametry/pricing.config.ts)
//hasta que se migren las cuentas
export type Subscription = 'Free' | 'A' | 'B' | 'C' | 'BASIC' | 'PRO' | 'PROPLUS' | (string & {});
export type ConnectionWsp = 'none' | 'icloudmeta';

/* Conexión de WhatsApp normalizada. Hoy la única integración es Meta ('icloudmeta'); 'none' es una cuenta sin conexión.
   Un valor que ya no existe (por ejemplo el viejo 'apirevolution') se toma como 'none' y, si falta el campo, como 'icloudmeta'.
   Solo normaliza en memoria: no corrige el dato guardado */
export function getConnectionWsp(user: object | null | undefined): ConnectionWsp {
    const connection = (user as Partial<AdministrationUser>)?.connectionWsp;
    if (!connection) {
        return 'icloudmeta';
    }
    return connection === 'icloudmeta' || connection === 'none' ? connection : 'none';
}

/* Estado real de la conexión de WhatsApp (AF327). Lo guarda WspStatusService después de consultar a n8n (estado-conexion).
   status: el valor de YCloud sin mapear (CONNECTED, DISCONNECTED, BANNED...) o 'NOT_FOUND' si el número no está en YCloud.
   provider: de qué conexión es el estado (para cuando se sume Meta directo, AF336) */
export interface WspStatus {
    provider: 'ycloud';
    status: string;
    checkedAt: any;
}

export interface AdministrationUser extends UserAuth {
    firstName: string;
    lastName: string;
    companyName: string;
    activity: string;
    cuit: string;
    uid?: string;
    parentUid?: string;
   phoneNumber:number | string;
    phoneArea: string;
    countryCode: string;
    status: UserStatus;
    role: 'company';
    code?: string;
    fcmTokens?: string;
    type: 'administration';
    activeBO?: boolean;
    redsocial?: boolean;
    numOrders?: number;
    dni?: string;
    country:string;
    administrationWsp:string;
    connectionWsp: ConnectionWsp;
    //estado real de la conexión de WhatsApp (AF327). Falta hasta la primera consulta
    wspStatus?: WspStatus;
    subscription: Subscription;
    city: string;
    province: string;
    source: 'consorcios';
    direction:{street:string,number:string,floor?:string,apartment?:string};
    createdAt?: Date;
    // Representa si ya creo el primer consorcio o no. Es decir nace en false y al  crear el primer consorcio pasa a true.
    firstConsorcio:boolean;
    customServices?: string[];
    emergencyPhoneArea?: string;
    emergencyPhoneNumber?: number | string;
    //mensajes disponibles de la administración. Lo actualiza el backend
    messageBalance?: MessageBalance;
    //si es true, los consorcistas pendientes y mudanzas que se registren desde el formulario se aceptan solos (ver auto-close-registration en functions)
    autoAceptRegistration?: boolean;
}

/* Esta clase existe para inicializar los usuarios de administración al momento de registrarse y evitar errores con los tipos asi como evitar escribir todo de nuevo */
export class AdministrationUserClass implements AdministrationUser {
    constructor(data: Omit<AdministrationUser, 'connectionWsp' | 'status' | 'role' | 'type' | 'source' | 'subscription' | 'numOrders' | 'firstConsorcio'>) {
        Object.assign(this, data);
        this.role = 'company';
        this.type = 'administration';
        this.status = 'active';
        this.source = 'consorcios';
        this.uid = 'administration';
        this.createdAt = new Date();
        this.subscription='Free';
        this.firstConsorcio=false;
        this.numOrders=0;
        this.connectionWsp = 'icloudmeta';


        this.data = {};
        Object.assign(this.data, data);
        this.data.role = 'company';
        this.data.type = 'administration';
        this.data.status = 'active';
        this.data.source = 'consorcios';
        this.data.uid = 'administration';
        this.data.createdAt = this.createdAt;
        this.data.subscription='Free';
        this.data.firstConsorcio=false;
        this.data.numOrders=0;
        this.data.connectionWsp = 'icloudmeta';
    }
    companyName: string;
    activity: string;
    direction: { street: string; number: string; floor?: string; apartment?: string; };
    administrationWsp: string;
    firstName: string;
    email: string;
    password: string;
    lastName: string;
    cuit: string;
    uid?: string;
    parentUid?: string;
    phoneNumber:number | string;
    phoneArea: string;
    status: UserStatus;
    createdAt?: Date;
    role: 'company';
    code?: string;
    fcmTokens?: string;
    type: 'administration';
    activeBO?: boolean;
    redsocial?: boolean;
    numOrders?: number;
    subscription: Subscription;
    dni?: string;
    country: string;
    connectionWsp: ConnectionWsp;
    countryCode: string;
    city: string;
    province: string;
    source: 'consorcios';
    firstConsorcio: boolean;
    customServices?: string[];
    emergencyPhoneArea?: string;
    emergencyPhoneNumber?: number | string;
    data:any;
    businessHours?: string;
    agentQuestions?:agentQuestion[];
    autoAceptRegistration?: boolean;
}